export default __webpack_public_path__ + "static/Uradzka-1-ef1a47d34b546779df2fbd4159fe45c1.png";